import React from "react";
import { Box } from "@mui/material";
import Field from "../shared/Field";
import ImageUploadField from "../../../../components/ImageUploadField";

const FormTestimonials = ({ draft, setDraft }) => (
  <Box>
    <Field
      label="Featured Quote"
      value={draft.quote}
      onChange={(v) => setDraft((p) => ({ ...p, quote: v }))}
      multiline
      placeholder="From wireframes to deployment..."
    />
    <Box display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
      <Field
        label="Reviewer Name"
        value={draft.reviewerName}
        onChange={(v) => setDraft((p) => ({ ...p, reviewerName: v }))}
        placeholder="Elena Wordington"
      />
      <Field
        label="Reviewer Role"
        value={draft.reviewerRole}
        onChange={(v) => setDraft((p) => ({ ...p, reviewerRole: v }))}
        placeholder="CTO, SomeStartup"
      />
    </Box>
    <ImageUploadField
      label="Reviewer Photo"
      value={draft.reviewerPhoto}
      onChange={(v) => setDraft((p) => ({ ...p, reviewerPhoto: v }))}
    />
  </Box>
);

export default FormTestimonials;
